(function () {
  var doc = document;
  var reduceMotion = window.matchMedia(
    '(prefers-reduced-motion: reduce)'
  ).matches;
  var finePointer = window.matchMedia('(pointer: fine)').matches;

  if (reduceMotion || !finePointer) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (!window.Lenis) return;

  var preventSelector = [
    'cart-drawer',
    'cart-drawer-items',
    'details-modal',
    'menu-drawer',
    'modal-dialog',
    'product-modal',
    '.drawer',
    '.bk-qv-drawer',
    '.bk-calendar__scroll',
    '.mobile-facets',
    '.predictive-search',
    '.search-modal',
    '.slider',
    '[data-lenis-prevent]',
  ].join(',');

  var lenis = new window.Lenis({
    anchors: true,
    autoRaf: true,
    autoResize: true,
    lerp: 0.08,
    overscroll: false,
    smoothWheel: true,
    syncTouch: false,
    prevent: function (node) {
      return Boolean(node && node.closest && node.closest(preventSelector));
    },
  });

  var style = doc.createElement('style');
  style.textContent = [
    'html.bk-lenis,html.bk-lenis body{scroll-behavior:auto!important;overscroll-behavior:none;overflow-anchor:none;}',
    'html.bk-lenis .gradient{background-attachment:scroll!important;}',
  ].join('');
  doc.head.appendChild(style);

  doc.documentElement.classList.add('bk-lenis');

  function resize() {
    if (lenis && lenis.resize) lenis.resize();
  }

  window.addEventListener('load', resize, { once: true });
  window.addEventListener('resize', resize, { passive: true });

  if (doc.fonts && doc.fonts.ready) {
    doc.fonts.ready.then(resize).catch(function () {});
  }

  window.BKSmoothScroll = {
    instance: lenis,
    scrollTo: function (target, options) {
      lenis.scrollTo(target, options);
    },
    start: function () {
      lenis.start();
    },
    stop: function () {
      lenis.stop();
    },
    destroy: function () {
      lenis.destroy();
      window.removeEventListener('resize', resize);
      if (style.parentNode) style.parentNode.removeChild(style);
      doc.documentElement.classList.remove('bk-lenis');
    },
  };
})();
